<template>
  <div class="about">
     <v-card
      class="mx-auto default"
      max-width="400"
      >
      <v-card-title>
        QA status
      </v-card-title>

       <v-card-text>
         <h1 v-if="qaStatus" class="up">UP</h1>
         <h1 v-else class="down">DOWN</h1>
         Laatst toewijzing: {{this.lastQAMessage}}
         </v-card-text>
     </v-card>

      <v-card class="justify-center default">
      <v-card-title>
        Overzicht werking perrontoewijzing
        <v-spacer></v-spacer>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="loops"
        hide-default-footer
        :items-per-page="1000"
      >

        <template v-slot:item.enabled="{ item }">
          <span v-if="item.enabled">ja</span>
          <span v-else>nee</span>
        </template>
        <template v-slot:item.available="{ item }">
          <span v-if="item.available">ja</span>
          <span v-if="item.available==false">nee</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
  
</template>

<script>
import moment from "moment";


export default {
  data() {
    return {
      headers: [
        { text: "Perron", value: "sidecode", align: "end"},
        {
          text: "Functie lus",
          value: "type"
        },
        { text: "Tijdstip laatste detectie", value: "last_detection" },
        { text: "Tonen voorkeurperron", value: "available"},
        { text: "Lus gebruikt", value: "enabled"},
        { text: "Quay", value: "quaycode" },
        { text: "VCU", value: "vcu" },
        { text: "Lus nummer", value: "loopnumber" }
      ],
      loops: [],
      lastQAMessage: null,
    };
  },
  computed: {
    qaStatus: function () {
      const now = moment();
      const lastMessage = moment(this.lastQAMessage);
      console.log(now.diff(lastMessage, 'seconds') < 600);
      return now.diff(lastMessage, 'seconds') < 600;
    }

  },
  created () {
    this.fetchLoopStatus();
    this.fetchQAStatus();
    this.timer = setInterval(this.fetchLoopStatus, 10000);
    this.timer2 = setInterval(this.fetchQAStatus, 10000);
  },
  methods: {
    fetchLoopStatus () {
      this.$http.get("/status/loops").then(response => {
        this.loops = response.data;
      });
    },
    fetchQAStatus() {
      this.$http.get("/status/quay_assignment").then(response => {
        this.lastQAMessage = response.data.last_quay_assignment_msg;
      });
    },
  },
  beforeDestroy () {
    clearInterval(this.timer);
    clearInterval(this.timer2);
  }
};
</script>

<style scoped>
#content {
  max-width: 1000px;
  align-content: center;
}
.up {
  color: green;
}
.down {
  color: red;
}
.default {
  margin: 4px;
}
</style>